// extracted by mini-css-extract-plugin
module.exports = {"container":"Address_container__1Ndzi","blockie":"Address_blockie__3cj53","address":"Address_address__27DTj"};